// v2.0.0 - 2026-02-02 - Member detail page using MemberDetail component

import { MemberDetail } from './members'

export default function MemberDetailPage() {
  return <MemberDetail />
}
